import styled from "styled-components"

export const ContainerFluid = styled.div`
  text-align: center;
  margin-top: 5rem;
`
export const Container = styled.div`
  width: 65%;
  margin: auto;

  @media (max-width: 1600px) {
    width: 80%;
  }

  @media (max-width: 1400px) {
    width: 90%;
  }
`
export const Header6 = styled.h6`
  font-weight: 500;
  color: #10ad62;
`
export const Header3 = styled.h3`
  margin-top: 0.5rem;
`
